import Tooltip from "../../Tooltip/Tooltip";
import { LuChevronRight } from "react-icons/lu";
import { GrCircleQuestion } from "react-icons/gr";

const QuestionIcon = () => (
  <GrCircleQuestion className="table__date__icon" size={19}/>
);
import { FormattedMessage } from "react-intl";

const CocoListing = ({
  cocoConfig,
  cocoConfigLabel,
  isOpenRequiredFields,
  setIsOpenRequiredFields,
}) => {
  return (
    <div className="cococonfig__lists-content">
      <div className="cococonfig__container row py-3">
        <div className="col-sm-4">
          <p>
            <span className="pe-1">
              {cocoConfigLabel?.signatureField?.textLabel}
            </span>
            <Tooltip
              position="left"
              text={cocoConfigLabel?.signatureField?.tooltipLabel}
              type="coco-config"
            >
              <QuestionIcon />
            </Tooltip>
          </p>
        </div>
        <div className="col-sm-8">
          <p>{cocoConfig?.signatureField || ""}</p>
        </div>
      </div>
      <div className="cococonfig__container row py-3">
        <div className="col-sm-4">
          <p>
            <span className="pe-1">
              {cocoConfigLabel?.emailTypes?.textLabel}
            </span>
            <Tooltip
              position="left"
              text={cocoConfigLabel?.emailTypes?.tooltipLabel}
              type="coco-config"
            >
              <QuestionIcon />
            </Tooltip>
          </p>
        </div>
        <div className="col-sm-8">
          <p>{cocoConfig?.emailTypes || ""}</p>
        </div>
      </div>
      <div className="cococonfig__container row py-3">
        <div className="col-sm-4">
          <p>
            <span className="pe-1">
              {cocoConfigLabel?.collectMethods?.textLabel}
            </span>
            <Tooltip
              position="left"
              text={cocoConfigLabel?.collectMethods?.tooltipLabel}
              type="coco-config"
            >
              <QuestionIcon />
            </Tooltip>
          </p>
        </div>
        <div className="col-sm-8">
          <p>
            {cocoConfig?.collectMethods ||
              cocoConfigLabel?.collectMethods?.default ||
              ""}
          </p>
        </div>
      </div>
      <div className="cococonfig__container row py-3">
        <div className="col-sm-4">
          <p>
            <span className="pe-1">
              {cocoConfigLabel?.requiredFieldsError?.textLabel}
            </span>
            <Tooltip
              position="left"
              text={cocoConfigLabel?.requiredFieldsError?.tooltipLabel}
              type="coco-config"
            >
              <QuestionIcon />
            </Tooltip>
          </p>
        </div>
        <div className="col-sm-8">
          <p>{cocoConfig?.requiredValidationError || ""}</p>
        </div>
      </div>
      <div className="cococonfig__container row py-3">
        <div className="col-sm-4">
          <p>
            <span className="pe-1">
              {cocoConfigLabel?.requiredSenderNameInPayload?.textLabel}
            </span>
            <Tooltip
              position="left"
              text={cocoConfigLabel?.requiredSenderNameInPayload?.tooltipLabel}
              type="coco-config"
            >
              <QuestionIcon />
            </Tooltip>
          </p>
        </div>
        <div className="col-sm-8">
          <p>{cocoConfig?.requiredSenderNameInPayload || ""}</p>
        </div>
      </div>
      <div className="cococonfig__container row py-3">
        <div className="col-sm-4">
          <p>
            <span className="pe-1">
              {cocoConfigLabel?.purposeList?.textLabel}
            </span>
            <Tooltip
              position="left"
              text={cocoConfigLabel?.purposeList?.tooltipLabel}
              type="coco-config"
            >
              <QuestionIcon />
            </Tooltip>
          </p>
        </div>
        <div className="col-sm-8">
          <p>{cocoConfig?.purposeList || ""}</p>
        </div>
      </div>

      <div
        className="cococonfig__container row py-3 clickable"
        onClick={() => setIsOpenRequiredFields(!isOpenRequiredFields)}
      >
        <div className="cococonfig__container-accordion d-flex align-items-center gap-1">
          <LuChevronRight
            size={22}
            className={`${isOpenRequiredFields ? "rotate active" : "rotate "}`}
          />
          <p> {cocoConfigLabel?.requiredFieldsGroup?.textLabel} </p>
        </div>
        <div
          className={`cococonfig__container-accordion-content ${
            isOpenRequiredFields ? "active" : ""
          }`}
        >
          <div className="pt-3 row gy-1">
            <div className="col-sm-4">
              <p>
                <FormattedMessage
                  id="cococonfig.Configuration"
                  defaultMessage="Configuration"
                />
              </p>
            </div>
            <div className="col-sm-8">
              <p>
                {" "}
                <FormattedMessage
                  id="cococonfig.Value"
                  defaultMessage="Value"
                />
              </p>
            </div>
            <div className="row gy-2">
              <div className="col-sm-4">
                <p>
                  <span className="pe-1">
                    {cocoConfigLabel?.requiredFields?.textLabel}
                  </span>
                  <Tooltip
                    position="left"
                    text={cocoConfigLabel?.requiredFields?.tooltipLabel}
                    type="coco-config"
                  >
                    <QuestionIcon />
                  </Tooltip>
                </p>
              </div>
              <div className="col-sm-8">
                <p>{cocoConfig?.requiredFields || ""}</p>
              </div>
            </div>
            <div className=" row gy-1">
              <div className="col-sm-4">
                <p>
                  <span className="pe-1">
                    {cocoConfigLabel?.requiredAnyOfFields?.textLabel}
                  </span>
                  <Tooltip
                    position="left"
                    text={cocoConfigLabel?.requiredAnyOfFields?.tooltipLabel}
                    type="coco-config"
                  >
                    <QuestionIcon />
                  </Tooltip>
                </p>
              </div>
              <div className="col-sm-8">
                <p>{cocoConfig?.requiredAnyFields || ""}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cococonfig__container row py-3">
        <div className="col-sm-4">
          <p>
            <span className="pe-1">
              {cocoConfigLabel?.requiredRemoteHcpFormPreview?.textLabel}
            </span>
            <Tooltip
              position="left"
              text={cocoConfigLabel?.requiredRemoteHcpFormPreview?.tooltipLabel}
              type="coco-config"
            >
              <QuestionIcon />
            </Tooltip>
          </p>
        </div>
        <div className="col-sm-8">
          <p>{cocoConfig?.requiredFormPreview || ""}</p>
        </div>
      </div>
    </div>
  );
};

export default CocoListing;
